module.exports = __webpack_public_path__ + "img/ad03.a3e523ca.png";